@for (answer of answers; track trackByAnswer($index, answer); let lastAnswer = $last) {
  @if (hasAnswers(answer)) {
    <div avoid-page-break [attr.margin-bottom-large]="!lastAnswer ? '' : null">
      @if (isSimple(answer.questionKind)) {
        <rt-heading>{{ answer.questionTitle }}</rt-heading>
        <div class="simple-answer-content">{{ answer.content }}</div>
      }

      @if (isBoolean(answer.questionKind)) {
        <rt-heading>{{ answer.questionTitle }}</rt-heading>
        <div class="simple-answer-content">
          {{ getBooleanAnswer(answer.content!) }}
        </div>
      }

      @if (isMultiChoice(answer.questionKind)) {
        <rt-heading>{{ answer.questionTitle }}</rt-heading>
        <div layout layout-full-width>
          <rt-list>
            @for (content of answer.contents; track trackByContent($index, content)) {
              <rt-item layout-align-items-center>
                @if (content) {
                  <rt-icon name="check" size="small"> </rt-icon>
                  {{ content }}
                }
              </rt-item>
            }
          </rt-list>
        </div>
      }

      @if (isScorecard(answer.questionKind)) {
        <rt-heading>{{ answer.questionTitle }}</rt-heading>
        <rt-box variant="default vertical no-padding" margin-top-small>
          <div class="box-body">
            @for (
              option of filterEmptyOptions(answer);
              track trackByOption(i, option);
              let lastOption = $last;
              let i = $index
            ) {
              <div layout-horizontal layout-align-items-center padding-lr padding-tb-small>
                <div layout-vertical layout-flex-1>
                  <rt-heading class="subheading" margin-bottom-small-x>
                    {{ option.title }}
                  </rt-heading>
                </div>
                <rt-interview-evaluation-rating
                  [rating]="filterEmptyContents(answer.contents!)[i]"
                  [translations]="ratingLevelTranslations"
                  variant="hasLabel"
                >
                </rt-interview-evaluation-rating>
              </div>
              @if (!lastOption) {
                <rt-divider></rt-divider>
              }
            }
          </div>
        </rt-box>
      }

      @if (isFile(answer.questionKind)) {
        <rt-heading>{{ answer.questionTitle }}</rt-heading>
        <div layout margin-top-small>
          <rt-attachments-list
            [attachments]="answer.attachments!"
            [canManageCandidates]="canManageCandidates"
            [small]="true"
          >
          </rt-attachments-list>
          @if (answer.attachments?.length !== 0) {
            <span class="print-attachments">{{ translations.attachment }}</span>
          }
        </div>
      }
    </div>
  }
}
